<template>
  <div class="content">
    <header-top></header-top>
    <div class="center">
      <el-form
        :model="form"
        :rules="formRules"
        ref="formRef"
        label-width="120px"
        label-position="right"
      >
        <el-form-item label="用户须知：">
          <div> 1.*表示必填 <br />2.所填信息必须真实，不得随意捏造，污蔑他人。</div>
        </el-form-item>

        <el-form-item label="类型：" prop="type">
          <el-radio v-model="form.type" :label="1">咨询</el-radio>
          <el-radio v-model="form.type" :label="2">建议</el-radio>
          <el-radio v-model="form.type" :label="3">感谢</el-radio>
          <el-radio v-model="form.type" :label="4">投诉</el-radio>
          <el-radio v-model="form.type" :label="5">其他</el-radio>
        </el-form-item>

        <el-form-item label="姓名：" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>

        <el-form-item label="电子邮箱：" prop="email">
          <el-input v-model="form.email" type="email"></el-input>
        </el-form-item>

        <el-form-item label="联系电话：" prop="mobile">
          <el-input v-model="form.mobile"></el-input>
        </el-form-item>

        <el-form-item label="联系地址：" prop="addr">
          <el-input v-model="form.addr"></el-input>
        </el-form-item>

        <el-form-item label="标题：" prop="title">
          <el-input v-model="form.title"></el-input>
        </el-form-item>

        <el-form-item label="内容：" prop="content">
          <el-input v-model="form.content" type="textarea"></el-input>
        </el-form-item>

        <el-form-item label="附件：" prop="options">
          <div>请上传图片类型的附件，格式为jpg或png，大小不能超过5M</div>
          <el-upload
              :action="domain"
              :before-upload="beforUp"
              :on-success="handleSuccess"
              :data="formData"
              :show-file-list="false"
              :multiple="true"
              accept="image/png, image/jpg, image/jpeg"
              class="uploadBox"
            >
              <div v-for="(item,index) in form.options" :key="index" class="imgBox">
                <img :src="item" />
                <span class="iconfont icon-guanbi" @click.stop="deleteFile(index)"></span>
              </div>
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
        </el-form-item>

        <el-form-item label="是否公开：" prop="open" required>
          <el-radio v-model="form.open" :label="0">不公开</el-radio>
          <el-radio v-model="form.open" :label="1">公开</el-radio>
        </el-form-item>

        <el-form-item class="btn">
          <el-button type="primary" @click="save">提交</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <foot></foot>
  </div>
</template>

<script>
import foot from "@/components/footer.vue";
import headerTop from "@/components/header.vue";
import { uploadImg,create } from "@/api/common.js";

export default {
  components: {
    foot,
    headerTop
  },
  data() {
    return {
      form: {
        type: 1,
        name: "",
        email: "",
        mobile: "",
        addr: "",
        title: "",
        content: "",
        options: [],
        open: 0
      },
      formRules: {
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min:2,max:10, message: "长度在2到10个字符", trigger: "blur" }
        ],
        mobile: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          { min:2,max:50, message: "长度在2到50个字符", trigger: "blur"}
        ],
        content: [
          { required: true, message: "请输入内容", trigger: "blur" },
          { min:2,max:255, message: "长度在255个字符以内", trigger: "blur"}
        ],
        open: [{ required: true, message: "请选择是否公开", trigger: "change" }]
      },
      domain: "",
      formData: {},
      baseUrl: ""
    };
  },
  methods: {
    beforUp() {
      return uploadImg().then(res => {
        this.domain = res.data.uploadUrl;
        this.formData = {
          token: res.data.uploadToken
        };
        this.baseUrl = res.data.baseUrl;
      });
    },
    // 上传文件
    handleSuccess(response, file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        if (fileList[i].size / 1024 > 5000) {
          return;
        }
      }
      this.form.options.push(this.baseUrl + response.hash);
    },

    // 删除文件
    deleteFile(index) {
      this.form.options.splice(index, 1);
    },
    // 提交表单
    save() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          create('urgentadvisoryMaps',{...this.form}).then(res=>{
            this.$message.success('提交成功');
            this.open();
          })
        } else {
          return false;
        }
      });
      
    },
    // 开启弹出框
    open() {
      this.$alert("您已成功提交咨询，我们将会在1-3个工作日给出回复", {
        confirmButtonText: "确定",
        callback: action => {
          this.$router.push({
            path: "/message/consult/index"
          });
        }
      });
    },
    //重置表单
    reset(){
      this.$refs.formRef.resetFields();
    }
  }
};
</script>
<style lang="scss" scoped>
.center {
  width: 600px;
  margin: 10px auto 0;
}
/deep/.el-form {
  .el-form-item__label {
    font-size: 18px;
  }
}
.el-form-item__label,
div {
  font-size: 16px;
}
.file {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
  margin-bottom: 2px;
}
.btn {
  .el-button {
    width: 100px;
    margin-right: 50px;
  }
}
.el-icon-plus {
  width: 100px;
  height: 100px;
  border: 1px solid #ccc;
  text-align: center;
  line-height: 100px;
}
.imgBox {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 100px;
  height: 100px;
  margin: 0 3px 3px 0;
  img {
    width: 100%;
    height: 100%;
  }
  span {
    position: absolute;
    top: -10px;
    right: 0;
    color: #ccc;
  }
}
/deep/ .uploadBox {
  .el-upload {
    text-align: left;
  }
  i {
    text-align: center;
  }
}

@media screen and (min-width: 320px) and (max-width: 980px) {
  .center {
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
  }
}
</style>
<style>
  @media screen and (min-width: 320px) and (max-width: 980px) {
    .el-form-item.btn .el-form-item__content {
      margin-left: 0 !important;
      display: flex;
    }
    .el-form-item.btn .el-form-item__content button {
      margin-right: 0;
      flex: 1;
    }
  }
</style>